import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponentComponent } from './components/header-component/header-component.component';
import { MenuComponentComponent } from './components/menu-component/menu-component.component';
import { LinkRepositoryComponent } from './components/link-repository/link-repository.component';
import { ModalComponent } from '../shared/components/modal/modal.component';
import { CodeRenderComponent } from './components/code-render/code-render.component';

@NgModule({
  declarations: [
    HeaderComponentComponent,
    MenuComponentComponent,
    LinkRepositoryComponent,
    ModalComponent,
    CodeRenderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HeaderComponentComponent,
    MenuComponentComponent,
    LinkRepositoryComponent,
    ModalComponent,
    CodeRenderComponent
  ]
})
export class SharedModule { }
